/* Copyright 2013 - 2022 Waiterio LLC */
const colorPrimary = '#8f95d3'

export default colorPrimary
